package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_12_28_Day_1
import com.veldekar.components.logs.Log_2024_12_28_Day_2
import com.veldekar.components.logs.Log_2024_12_28_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-12-28")
@Composable
public fun Log_2024_12_28(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Scorpions in Vor's Desert",
        ogTitle = "Scorpions in Vor's Desert",
        date = LocalDate(2_024, 12, 28),
        ogDescription = "The Deetry family fled when faced with giant scorpions, but heroes run toward danger. The fastest of our heroes, Bigglesworth the Brave, falls in battle.",
        ogImage = "images/bigglesworthFallsInBattleLinkPreview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 628,
        ogImageAlt = "An animated GIF showing a LEGO scorpion-like creature killing a LEGO monkey (representing Bigglesworth).",
    ) {
        SessionDayHeader(dayId = "newgrowth-67", dateString = "Newgrowth 67")
        Log_2024_12_28_Day_1()
        SessionDayHeader(dayId = "newgrowth-68", dateString = "Newgrowth 68")
        Log_2024_12_28_Day_2()
        SessionDayHeader(dayId = "newgrowth-69", dateString = "Newgrowth 69")
        Log_2024_12_28_Day_3()
        SessionMediaItem(
            image = "images/bigglesworthFallsInBattle.gif",
            linkImage = "images/bigglesworthFallsInBattle.gif",
            description = "An animated GIF showing a LEGO scorpion-like creature killing a LEGO monkey (representing Bigglesworth).",
            width = 1_210,
            height = 907,
        )
    }
}
